import React, { useLayoutEffect, useRef, useState } from 'react';
import { hotspotMarkerVariables } from './HotspotMarker';
import { hotspotPreviewVariables } from './hotspotPreviewScale';

export default function HotspotPositionPreview({ blockId, appearance, children }) {
  const ref = useRef(null);
  const [variables, setVariables] = useState({});
  useLayoutEffect(() => {
    const preview = ref.current;
    const previewImage = preview?.querySelector('img');
    const documents = [document.getElementById('preview-frame')?.contentDocument, document].filter(Boolean);
    const source = documents.map((doc) => doc.getElementById(blockId)).find((element) => element?.querySelector('[data-hotspot-surface]'));
    const sourceImage = source?.querySelector('[data-hotspot-surface]');
    const sourceNumber = source?.querySelector('[data-hotspot-number]');
    if (!previewImage || !sourceImage || !sourceNumber) return undefined;
    const update = () => {
      const sourceStyle = sourceNumber.ownerDocument.defaultView.getComputedStyle(sourceNumber);
      const sourceBounds = sourceNumber.getBoundingClientRect();
      const next = hotspotPreviewVariables({
        sourceImageWidth: sourceImage.getBoundingClientRect().width,
        sourceMarkerWidth: sourceBounds.width,
        sourceLayoutWidth: parseFloat(sourceStyle.width) || sourceNumber.offsetWidth || sourceBounds.width,
        sourceFontSize: parseFloat(sourceStyle.fontSize),
        previewImageWidth: previewImage.getBoundingClientRect().width,
      });
      setVariables((current) => Object.keys(next).length === Object.keys(current).length
        && Object.keys(next).every((key) => next[key] === current[key]) ? current : next);
    };
    const observers = new Map();
    [sourceImage, sourceNumber, previewImage].forEach((element) => {
      const owner = element.ownerDocument.defaultView;
      if (!observers.has(owner)) {
        observers.set(owner, owner.ResizeObserver ? new owner.ResizeObserver(update) : null);
        owner.addEventListener('resize', update);
      }
      observers.get(owner)?.observe(element);
    });
    preview.addEventListener('load', update, true);
    update();
    return () => {
      observers.forEach((observer, owner) => {
        observer?.disconnect();
        owner.removeEventListener('resize', update);
      });
      preview.removeEventListener('load', update, true);
    };
  }, [blockId]);
  return <div ref={ref} data-hotspot-placement style={{ ...hotspotMarkerVariables(appearance), ...variables }}>{children}</div>;
}
